import { EntryErrorListField } from '../../../../types/types';
import { formatString } from '../../../../utils/formatString';

// Formats one cell of an inlined entry error list. Row fields follow the
// 'fields' order. The format comes from formatField (format string stored in
// another field of the same row) or formatStr; no format means the plain value.
export const formatEntryListCell = (
  row: (string | number | null)[],
  field: EntryErrorListField,
  fields: EntryErrorListField[]
): string => {
  const valueIndex = fields.findIndex((f) => f.name === field.name);
  const value = row[valueIndex];
  const stringValue =
    value === null || value === undefined ? '' : String(value);

  let format = field.formatStr;
  if (field.formatField) {
    const formatIndex = fields.findIndex((f) => f.name === field.formatField);
    const formatValue = formatIndex === -1 ? null : row[formatIndex];
    format =
      formatValue === null || formatValue === undefined
        ? undefined
        : String(formatValue);
  }

  if (!format || value === null || value === undefined) {
    return stringValue;
  }

  // ASW's '%n' number placeholder is not a sprintf conversion — map it to %s
  // so sprintf-compatible formats (%s, %.2f, ...) run through formatString.
  const sprintfFormat = format.replace(/%n/g, '%s');
  return String(formatString(sprintfFormat, value));
};
